module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"PDF export","section":"Select the version of the <strong>completed</strong> ESG questionnaire you want to export.","btn":"Create PDF"},"de":{"title":"PDF Exportieren","section":"Wählen Sie die Version des <strong>abgeschlossenen</strong> ESG-Fragebogens aus, den Sie exportieren möchten.","btn":"PDF erstellen"}}')
  delete Component.options._Ctor
}
